import { activities } from './crmservices/activities'
import { authentication } from './crmservices/authenticate'
import { config } from './crmservices/config'
import { httpBackOfficeUtil } from './crmservices/httpBackOfficeUtil'
import { orders } from './crmservices/orders'
import { subscriptions } from './crmservices/subscriptions'
import { contacts } from './crmservices/contacts'
import { attachments } from './crmservices/attachments'


export default {
    config: config,
    activities: activities,
    orders: orders,
    authentication: authentication,
    subscriptions: subscriptions,
    contacts: contacts,
    attachments:attachments,
    setupChannel: httpBackOfficeUtil.setupChannel,
    getSession: httpBackOfficeUtil.getSession,
    startSession: httpBackOfficeUtil.startSession,
    cleanSession: httpBackOfficeUtil.startSession,
}
